import { render, staticRenderFns } from "./shareButton.vue?vue&type=template&id=08bc006e&scoped=true&"
import script from "./shareButton.vue?vue&type=script&lang=js&"
export * from "./shareButton.vue?vue&type=script&lang=js&"
import style0 from "./shareButton.vue?vue&type=style&index=0&id=08bc006e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc006e",
  null
  
)

export default component.exports